import api from '../api'
import type { AxiosResponse } from 'axios'
import type { CompanyProfile, CompanyMarketData, CompanyIndustryOption } from '@/types/company'

export const getCompanyProfile = (): Promise<AxiosResponse<CompanyProfile>> => {
  return api.get('/company/v2/profile', { role: 'company' })
}

export const getCompanyIndustryOptions = (): Promise<AxiosResponse<{ data: CompanyIndustryOption[] }>> => {
  return api.get('/company/v2/profile/industry-options', { role: 'company' })
}

export const saveCompanyDraft = (payload: Partial<CompanyProfile>): Promise<AxiosResponse<CompanyProfile>> => {
  return api.patch('/company/v2/profile', payload, { role: 'company' })
}

export const discardCompanyDraft = (): Promise<AxiosResponse<CompanyProfile>> => {
  return api.delete('/company/v2/profile/draft', { role: 'company' })
}

export const publishCompanyProfile = (
  payload: Partial<CompanyProfile>
): Promise<AxiosResponse<CompanyProfile>> => {
  return api.post('/company/v2/profile/publish', payload, { role: 'company' })
}

export const getCompanyMarketData = (ticker: string): Promise<AxiosResponse<CompanyMarketData>> => {
  return api.get(`/company/v2/profile/market-cap/${ticker}`, { role: 'company' })
}

export const getCompanyLogoUploadUrl = (
  fileType: string
): Promise<AxiosResponse<{ uploadUrl: string; publicUrl: string; expiresIn: string }>> => {
  return api.post(
    '/company/v2/profile/upload-logo',
    { fileType },
    { role: 'company' }
  )
}
